import { render, staticRenderFns } from "./current-conversation.vue?vue&type=template&id=45ab4434&"
import script from "./current-conversation.vue?vue&type=script&lang=js&"
export * from "./current-conversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports